<template>
    <div class="filter-bar">
        <div v-if="showSearch" class="form-control">
            <label>Szukaj</label>
            <input v-model="localSearch" type="text" placeholder="Wpisz nazwę..." />
        </div>

        <div v-for="filter in filtersSchema" :key="filter.key" class="form-control">
            <label>{{ filter.label }}</label>
            <select v-model="localFilters[filter.key]">
                <option :value="''">Wszystkie</option>
                <option
                    v-for="option in filter.options"
                    :key="option.id || option"
                    :value="option.id ?? option"
                >
                    {{ option.name ?? option }}
                </option>
            </select>
        </div>

        <div class="form-control">
            <label>Sortuj według</label>
            <select v-model="localSort.by">
                <option disabled value="">Wybierz</option>
                <option v-for="option in sortOptions" :key="option.key" :value="option.key">
                    {{ option.label }}
                </option>
            </select>
        </div>

        <div class="form-control">
            <label>Kolejność</label>
            <select v-model="localSort.order">
                <option value="asc">Rosnąco</option>
                <option value="desc">Malejąco</option>
            </select>
        </div>

        <button v-if="isDirty" class="btn btn-clear" @click="resetFilters">
            <font-awesome-icon icon="times" />
            Wyczyść
        </button>
    </div>
</template>

<script>
export default {
    name: 'EntityFilterBar',
    props: {
        filtersSchema: Array,
        sortOptions: Array,
        modelValue: Object,
        sort: Object,
        search: String,
        showSearch: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:filters', 'update:sort', 'update:search'],
    data() {
        return {
            localSearch: this.search || '',
            localSort: {
                by: this.sort?.by || '',
                order: this.sort?.order || 'asc'
            },
            localFilters: this.filtersSchema?.reduce((acc, f) => {
                acc[f.key] = this.modelValue?.[f.key] ?? ''
                return acc
            }, {}) || {}
        }
    },
    computed: {
        isDirty() {
            return (
                this.localSearch ||
                this.localSort.by ||
                this.localSort.order !== 'asc' ||
                Object.values(this.localFilters).some(Boolean)
            )
        }
    },
    watch: {
        localSearch(val) {
            this.$emit('update:search', val)
        },
        localSort: {
            deep: true,
            handler(val) {
                this.$emit('update:sort', val)
            }
        },
        localFilters: {
            deep: true,
            handler(val) {
                this.$emit('update:filters', val)
            }
        }
    },
    methods: {
        resetFilters() {
            this.localSearch = ''
            this.localSort = {
                by: '',
                order: 'asc'
            }

            const reset = {}
            for (const f of this.filtersSchema) {
                reset[f.key] = ''
            }
            this.localFilters = reset

            this.$emit('update:search', '')
            this.$emit('update:sort', {
                by: '',
                order: 'asc'
            })
            this.$emit('update:filters', reset)
        }
    },
    mounted() {
        this.$emit('update:search', this.localSearch)
        this.$emit('update:sort', this.localSort)
        this.$emit('update:filters', this.localFilters)
    }
}
</script>

<style lang="scss" scoped>
.filter-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.5rem;
    width: 100%;

    .form-control {
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1 1 auto;
        min-width: 160px;
        max-width: 100%;
        flex-shrink: 1;

        label {
            font-weight: 500;
            font-size: 0.95rem;
            color: $color-text;
        }

        input,
        select {
            font-family: 'Inter', sans-serif;
            padding: 8px 10px;
            border: 2px solid $color-grey;
            border-radius: 8px;
            font-size: 0.95rem;
            transition: border-color 0.3s ease;
            height: 38px;

            &:focus {
                border-color: $color-primary;
                outline: none;
            }
        }
    }

    .btn-clear {
        align-self: flex-end;
        background: $color-grey;
        color: $color-text;
        border: none;
        border-radius: 8px;
        padding: 8px 16px;
        font-size: 0.95rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        height: 38px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background: $color-primary-accent;
            color: white;
        }
    }
}

@media (max-width: 640px) {
    .filter-bar {
        flex-direction: column;

        .form-control {
            width: 100%;
        }

        .btn-clear {
            width: 100%;
        }
    }
}
</style>
